import { MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '@app/core/services/toast/toast.service';
import { DesignComplexityLogicService } from '@app/logic/design-complexity';
import { IBaseMappedItem } from '@app/logic/base/interfaces/i.base-mapped-item';
import { BaseDialogFormViewDirective } from '@app/shared/base-views/base-dialog-form-view.directive';
import { IDesignComplexityDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { take } from 'rxjs';

export abstract class DesignComplexityDialogFormViewBase<
    DtoType,
    MappedItemType extends IBaseMappedItem<DtoType, MappedItemType, LogicServiceType>,
    LogicServiceType,
> extends BaseDialogFormViewDirective<DtoType, MappedItemType, LogicServiceType> {
    public designComplexities: IDesignComplexityDto[] = [];

    protected constructor(
        dialogRef: MatDialogRef<any>,
        toastService: ToastService,
        protected readonly designComplexityLogicService: DesignComplexityLogicService,
    ) {
        super(dialogRef, toastService);
    }

    protected loadDesignComplexities(selectedId: number = 0): void {
        this.designComplexityLogicService
            .getDesignComplexitiesForSelection(selectedId)
            .pipe(take(1))
            .subscribe(result => this.designComplexities = result);
    }
}
